import { createFileRoute } from "@tanstack/react-router";
import ReviewSection from "@/pages/ReviewSection";

export const Route = createFileRoute("/reviews/$sectionSlug")({
  component: ReviewSection,
});
